import React from 'react'
import "./services.css";
import Image1 from "../../assests/service-1.svg";
import Image2 from "../../assests/service-2.svg";
import Image3 from "../../assests/service-3.svg";

const data = [
  {
    id: 2,
    image: Image2,
    title: "Competitive Programmer",
    description:
      "I likes to do competitive programming. I usually prefer c++ for the programmimg.",
  },
  {
    id: 1,
    image: Image1,
    title: "Web Development",
    description:
      "I am front end developer with the knowledge of react JS and HTML, CSS, Javascript.",
  },
  {
    id: 3,
    image: Image3,
    title: "Photo Editing",
    description:
      "I also likes to do editing of the photos.",
  },
];

const Services = () => {
  return (
    <section className="services container section" id="services">
      <h2 className="section__title">Skills</h2>
      <div className="services__container grid">
        {data.map(({id,image,title,description})=>{
          return(
            <div className="services__card" key={id}>
              <img src={image} alt="" className='services__img'/>

              <h3 className="services__title">{title}</h3>
              <p className="services__description">{description}</p>
            </div>
          )
        })}
      </div>
    </section>
  )
}

export default Services